import { render, staticRenderFns } from "./LandingOnboardingIntoPublicAdIntake.vue?vue&type=template&id=6064b0cc&scoped=true"
import script from "./LandingOnboardingIntoPublicAdIntake.vue?vue&type=script&lang=js"
export * from "./LandingOnboardingIntoPublicAdIntake.vue?vue&type=script&lang=js"
import style0 from "./LandingOnboardingIntoPublicAdIntake.vue?vue&type=style&index=0&id=6064b0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6064b0cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingAllNewOnboarding: require('/src/components/landing/LandingAllNewOnboarding.vue').default,LandingMyAdItem: require('/src/components/landing/LandingMyAdItem.vue').default})
